import script from "./SettingsOthersContent.vue?vue&type=script&setup=true&lang=ts"
export * from "./SettingsOthersContent.vue?vue&type=script&setup=true&lang=ts"

import "./SettingsOthersContent.vue?vue&type=style&index=0&id=d70653da&lang=css"

const __exports__ = script;

export default __exports__